import { useEffect, useRef } from "react";
import { isMobile, scroll2Top } from "../utils/utils";
import InfoOldContractBloc from "../blocs/info-old-contract/InfoOldContractBloc";




export default function InfoOldContractPage() {
    
    const pageGapRef = useRef<null | HTMLDivElement>(null);
    useEffect(() => {
      if (isMobile()) {
        pageGapRef.current?.scrollIntoView() 
      } else {
        scroll2Top();
      }
    }, []);

    
    return (
      <div className="entreprise-container">
        <h1 className="title ml-lg-desktop mb-sm">Résiliation de votre complémentaire santé</h1>
        <p className="text ml-lg-desktop mt-sm" style={{textAlign: 'justify'}}></p>
        <div ref={pageGapRef} className="page-gap" />
        <div className="m-lg-desktop">
           <InfoOldContractBloc />
        </div>
      </div>
    )

}